export default __webpack_public_path__ + "static/media/avatar_unicorn6.3d139cb3.mp3";